import { UpploadService } from "../service";
import { safeListen, fitImageToContainer, } from "../helpers/elements";
import { blobToUpploadFile } from "../helpers/files";
export default class Camera extends UpploadService {
    constructor() {
        super(...arguments);
        this.name = "Record";
        this.icon = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="film-alt" class="svg-inline--fa fa-film-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm384 192c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"></path></svg>`;
        this.color = "#16a085";
        this.canvas = document.createElement("canvas");
        this.gotError = false;
        this.waiting = false;
        this.frontCamera = false;
        this.isRecording = false;
        this.mediaChunks = [];
        this.blob = null;
        this.mediaBlobUrl = '';
        this.mediaRecorder;
        this.supports = () => !!(window.navigator.mediaDevices &&
            window.navigator.mediaDevices.enumerateDevices &&
            !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
        this.template = ({ translate }) => {
            return `
      <div class="service-main">
        <div class="camera-waiting">${translate("services.camera.waiting")}</div>
        <div class="camera-error">
          <p>${translate("services.camera.unableToRead")}</p>
          <p><a href="https://uppload.js.org/help/camera" target="_blank">${translate("needHelp")}</a></p>
        </div>
        <div class="camera-success">
          <video class="camera-stream w-full h-auto max-h-96" muted></video>
        </div>
      </div>
      <footer class="service-footer mt-4">
        <!--<button
          class="camera-switch uppload-button"
        >${translate("services.camera.switch")}</button>-->
        <button
          class="camera-start uppload-button uppload-button--cta"
          style="background: ${this.color}"
        >Start</button>
        <button
          class="camera-stop uppload-button uppload-button--cta hidden"
          style="background: ${this.color}"
        >Stop</button>
        <button
          class="camera-upload uppload-button uppload-button--cta hidden"
          style="background: ${this.color}"
        >Upload</button>
      </footer>
      <button class="need-help-link"><span>${translate("needHelp")}</span aria-hidden="true"><span>?</span></button>
    `;
        };
        this.stop = () => {
            if (this.stream)
                this.stream.getTracks().forEach((track) => track.stop());
        };
        this.handlers = (params) => {
            const upploader = document.querySelector('.uppload-container');
            if (!upploader) return;

            this.waiting = true;
            this.update(params);
            const constraints = {
                audio: false,
                video: { width: 1280, height: 1280 },
            };
            this.startStream(params, constraints);
            const startButton = params.uppload.container.querySelector(".camera-start");
            const stopButton = params.uppload.container.querySelector(".camera-stop");
            const uploadButton = params.uppload.container.querySelector(".camera-upload");
            if (startButton)
                safeListen(startButton, "click", this.startRecording.bind(this, params));
            if (stopButton)
                safeListen(stopButton, "click", this.stopRecording.bind(this));
            if (uploadButton)
                safeListen(uploadButton, "click", this.upload.bind(this, params));
            const switchButton = params.uppload.container.querySelector(".camera-click");
            if (switchButton)
                safeListen(switchButton, "click", this.switchCamera.bind(this, params));
            const helpButton = params.uppload.container.querySelector(".need-help-link");
            if (helpButton)
                safeListen(helpButton, "click", () => params.showHelp("/services/camera"));
        };
    }
    update(params) {
        const waiting = params.uppload.container.querySelector(".camera-waiting");
        if (waiting) {
            waiting.style.display = "none";
            waiting.style.opacity = "0";
        }
        const error = params.uppload.container.querySelector(".camera-error");
        if (error) {
            error.style.display = "none";
            error.style.opacity = "0";
        }
        const success = params.uppload.container.querySelector(".camera-success");
        if (success) {
            success.style.display = "none";
            success.style.opacity = "0";
        }
        const footer = params.uppload.container.querySelector(".service-footer");
        if (footer) {
            footer.style.display = "none";
            footer.style.opacity = "0";
        }
        if (this.gotError) {
            if (error) {
                error.style.display = "";
                error.style.opacity = "1";
            }
        }
        else if (this.waiting) {
            if (waiting) {
                waiting.style.display = "";
                waiting.style.opacity = "1";
            }
        }
        else {
            if (success) {
                success.style.display = "";
                success.style.opacity = "1";
            }
            if (footer) {
                footer.style.display = "";
                footer.style.opacity = "1";
            }
        }
    }
    switchCamera(params) {
        this.frontCamera = !this.frontCamera;
        const constraints = {
            audio: true,
            video: {
                width: 1280,
                height: 1280,
                facingMode: this.frontCamera ? "user" : "environment",
            },
        };
        this.startStream(params, constraints);
    }
    startRecording(params) {
      this.stop();
      const video = params.uppload.container.querySelector("video.camera-stream");
      const startButton = params.uppload.container.querySelector(".camera-start");
      const stopButton = params.uppload.container.querySelector(".camera-stop");
      const uploadButton = params.uppload.container.querySelector(".camera-upload");
      const constraints = {
        audio: true,
        video: {
            width: 1280,
            height: 1280,
            facingMode: this.frontCamera ? "user" : "environment",
        },
      };
      window.navigator.mediaDevices
          .getUserMedia(constraints)
          .then((mediaStream) => {
            this.isRecording = true;
            this.stream = mediaStream;
            startButton.classList.add('hidden')
            stopButton.classList.remove('hidden')
            this.mediaRecorder = new MediaRecorder(mediaStream);
            this.mediaRecorder.ondataavailable = (e) => this.mediaChunks.push(e.data);
            this.mediaRecorder.onstop = () => {
              const [chunk] = this.mediaChunks;
              const blobProperty = Object.assign(
                { type: chunk.type },
                { type: "video/mp4" }
              );
              const blob = new Blob(this.mediaChunks, blobProperty);
              const url = URL.createObjectURL(blob);
              this.blob = blob;
              this.mediaBlobUrl = url;

              if (video) {
                  video.srcObject = null;
                  video.src = this.mediaBlobUrl;
                  video.muted = false;
                  video.controls = true;
                  safeListen(video, "loadedmetadata", () => video.play());
                  fitImageToContainer(params, video);
              }

              stopButton.classList.add('hidden')
              uploadButton.classList.remove('hidden')

              this.stop();
            }
          this.mediaRecorder.start()
          if (video) {
              video.srcObject = mediaStream;
              video.muted = true;
              safeListen(video, "loadedmetadata", () => video.play());
              fitImageToContainer(params, video);
          }
      })
          .catch(() => {
          this.gotError = true;
      })
          .then(() => {
          this.waiting = false;
          this.update(params);
      });
    }
    stopRecording() {
      if (this.mediaRecorder) {
        if (this.mediaRecorder.state !== "inactive") {
          this.isRecording = false
          this.mediaRecorder.stop();
          this.stream &&
            this.stream.getTracks().forEach((track) => track.stop());
          this.mediaChunks = [];
        }
      }
    };
    upload(params) {
      params.next(blobToUpploadFile(this.blob, `camera-recording-${Math.random().toString(36).slice(2)}.webm`, "video/webm", new Date()))
    }
    startStream(params, constraints) {
        this.stop();
        window.navigator.mediaDevices
            .getUserMedia(constraints)
            .then((mediaStream) => {
            this.stream = mediaStream;
            const video = params.uppload.container.querySelector("video.camera-stream");
            if (video) {
                video.srcObject = mediaStream;
                safeListen(video, "loadedmetadata", () => video.play());
                fitImageToContainer(params, video);
            }
        })
            .catch(() => {
            this.gotError = true;
        })
            .then(() => {
            this.waiting = false;
            this.update(params);
        });
    }
}
//# sourceMappingURL=camera.js.map